import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  buttons: {
    marginTop: '1rem',
    alignSelf: 'end',
  },
  cancelButton: {
    backgroundColor: theme.palette.common.white,
  },
}));

export default useStyles;
